import { render, staticRenderFns } from "./HorizontalBarChartPlaceholder.vue?vue&type=template&id=19f9fde5&scoped=true&"
import script from "./HorizontalBarChartPlaceholder.vue?vue&type=script&lang=js&"
export * from "./HorizontalBarChartPlaceholder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19f9fde5",
  null
  
)

export default component.exports